const ZOHO_ORG = 'ndemnifly';

export const accountUrl = (accountId) =>
  `/account/${encodeURIComponent(accountId)}`;

export const dealUrl = (accountId, dealId) =>
  `/account/${encodeURIComponent(accountId)}/deal/${encodeURIComponent(dealId)}`;

export const crmDeepLink = (module, recordId) =>
  `https://crm.zoho.com/crm/${ZOHO_ORG}/tab/${module}/${recordId}`;

export const openContactPeek = (contactId) => ({ kind: 'contact', id: contactId });
export const openAircraftPeek = (aircraftId) => ({ kind: 'aircraft', id: aircraftId });
export const openCarrierPeek = (carrierId) => ({ kind: 'carrier', id: carrierId });

export const openEntityPeek = (kind, id) => {
  switch (kind) {
    case 'contact': return openContactPeek(id);
    case 'aircraft': return openAircraftPeek(id);
    case 'carrier': return openCarrierPeek(id);
    default: throw new Error(`Unknown entity kind: ${kind}`);
  }
};
